var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = "_blank";
    links[i].rel = "noreferrer noopener";
  }
}

$(document).ready(function () {
  var currentPath = window.location.pathname.match(/\/products\/[^/]+/);
  currentPath = currentPath ? currentPath[0] : "";

  $(".product_btn a").each(function () {
    var linkPath = new URL(this.href).pathname.match(/\/products\/[^/]+/);
    linkPath = linkPath ? linkPath[0] : "";

    if (linkPath === currentPath) {
      $(this).addClass("button--solid");
      $(this).removeClass("button--outline");
    } else {
      $(this).addClass("button--outline");
      $(this).removeClass("button--solid");
    }
  });
});

// ABZ Video Section
$(".video_sec").click(function() {
    var video = $("#video").get(0);
    var thumbnail = $("#thumbnail");
    
    if (video.paused) {
        video.play();
        $(".play").fadeOut(500);
        thumbnail.fadeOut(500); // Hide the thumbnail
    } else {
        video.pause();
        $(".play").fadeIn(500);
        thumbnail.fadeIn(500); // Show the thumbnail again
    }
});

